export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-2 h-6 md:h-7 rounded-full bg-primary-500"></span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">联系我们</h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10">有影片推荐、问题反馈或合作意向？欢迎联系我们</p>

        <div className="rounded-2xl bg-background-100 border border-background-200/40 p-6 md:p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-8">
            <div className="flex items-start gap-3">
              <span className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-500/15">
                <i className="ri-mail-line text-primary-400 text-lg"></i>
              </span>
              <div>
                <div className="text-sm font-semibold text-foreground-50 mb-1">商务合作</div>
                <p className="text-xs text-foreground-400">business@taozicinema.com</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-500/15">
                <i className="ri-movie-line text-accent-400 text-lg"></i>
              </span>
              <div>
                <div className="text-sm font-semibold text-foreground-50 mb-1">影片推荐</div>
                <p className="text-xs text-foreground-400">recommend@taozicinema.com</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-500/15">
                <i className="ri-question-line text-primary-400 text-lg"></i>
              </span>
              <div>
                <div className="text-sm font-semibold text-foreground-50 mb-1">问题反馈</div>
                <p className="text-xs text-foreground-400">support@taozicinema.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}